import { Paper, Stack, type StackProps, Typography } from '@mui/material'
import { type ReactElement, type ReactNode } from 'react'
import { getPxAsRem } from 'shared/utils'

interface ProfilePanelProps extends StackProps {
    /** An array of action elements such as icon buttons to display at the top right of this panel. */
    actionElements?: ReactElement[]
    /** A subtitle to display beneath this panel's title. Useful for secondary information like audit data. */
    panelSubtitle?: ReactNode
    /** The title to display at the top of this panel. */
    panelTitle: ReactNode
}

export function ProfilePanel({
    panelSubtitle,
    actionElements = [],
    panelTitle,
    children,
    ...props
}: ProfilePanelProps) {
    return (
        <Stack
            component={Paper}
            gap={getPxAsRem(16)}
            height="100%"
            padding={getPxAsRem(16)}
            {...props}
        >
            <Stack
                alignItems="flex-start"
                direction="row"
                justifyContent="space-between"
            >
                <Stack>
                    <Typography variant="h4">{panelTitle}</Typography>

                    {panelSubtitle && (
                        <Typography variant="detail">
                            {panelSubtitle}
                        </Typography>
                    )}
                </Stack>

                {actionElements.length > 0 && (
                    <Stack direction="row" gap={getPxAsRem(4)}>
                        {actionElements.map((element, index) => element)}
                    </Stack>
                )}
            </Stack>

            {children}
        </Stack>
    )
}
